import { useEffect, useMemo, useState } from "react";

import { useMediaQuery } from "@mui/material";

type ColorMode = "light" | "dark";

const useColorMode = () => {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const systemColorMode = useMemo(() => (prefersDarkMode ? "dark" : "light"), [prefersDarkMode]);

  const defaultColorMode = localStorage.getItem("color-mode") || systemColorMode;

  const [mode, setMode] = useState<ColorMode>(defaultColorMode as ColorMode);

  const colorMode = useMemo(
    () => ({
      toggleColorMode: (value: string) => {
        localStorage.setItem("color-mode", value);
        setMode(!value ? systemColorMode : value === "dark" ? "dark" : "light");
      },
    }),
    [systemColorMode]
  );

  useEffect(() => {
    if (!localStorage.getItem("color-mode")) {
      setMode(systemColorMode);
    }
  }, [systemColorMode]);

  return {
    mode,
    colorMode,
    isDarkMode: mode === "dark",
  };
};

export default useColorMode;
